export const openingArray = [
  {
    id: 'sr-dev',
    name: 'Senior Developer',
    img: '/images/careers/apply-banner.jpg',
    jobRole: [
      [
        '2+ years of experience as a Node.js Developer or backend developer.',
        'In depth knowledge of Node.js.',
        'Strong proficiency with JavaScript.',
        'Good understanding of at least one of AngularJS or React JS.',
        'A basic understanding of front-end technologies.',
        'Understanding the nature of asynchronous programming and its quirks and workarounds.',
        'Knowledge of OOPs and Design Patterns.',
        'Strong knowledge of cloud.'
      ],
      [
        'Ability to quickly get up to speed with existing code.',
        'Open-minded and keen to learn.',
        'Strong analytical skills and problem solving aptitude.',
        'Proficient understanding of code versioning tools, such as Git.',
        'Experience with Deployment to deploy updates and fixes.',
        'Knowledge of Ruby or Python will be a plus.',
        'Experience with Firebase will be a plus.'
      ]
    ],
    duties: [
      [
        'Integration of user-facing elements developed by a front-end developers with server side logic.',
        'Building reusable code and libraries for future use.',
        'Optimization of the application for maximum speed and scalability.',
        'Implementation of security and data protection.',
        'Design and implementation of data storage solutions.'
      ],
      [
        'Code, test and operate node.js based services and help QA and other teams for server-based testing.',
        'Effectively use tools and ingenuity to identify and fix defects before they become a problem.',
        'Independently create complete solutions from scratch.',
        'Implement and maintain monitoring and alerting.',
        'Share knowledge and help colleagues.'
      ]
    ]
  },
  {
    id: 'bk-dev',
    name: 'Backend Developer',
    img: '/images/careers/apply-banner.jpg',
    jobRole: [
      [
        '2+ years of experience as a Node.js Developer or backend developer.',
        'In depth knowledge of Node.js.',
        'Strong proficiency with JavaScript.',
        'Good understanding of at least one of AngularJS or React JS.',
        'A basic understanding of front-end technologies.',
        'Understanding the nature of asynchronous programming and its quirks and workarounds.',
        'Knowledge of OOPs and Design Patterns.',
        'Strong knowledge of cloud.'
      ],
      [
        'Ability to quickly get up to speed with existing code.',
        'Open-minded and keen to learn.',
        'Strong analytical skills and problem solving aptitude.',
        'Proficient understanding of code versioning tools, such as Git.',
        'Experience with Deployment to deploy updates and fixes.',
        'Knowledge of Ruby or Python will be a plus.',
        'Experience with Firebase will be a plus.'
      ]
    ],
    duties: [
      [
        'Integration of user-facing elements developed by a front-end developers with server side logic.',
        'Building reusable code and libraries for future use.',
        'Optimization of the application for maximum speed and scalability.',
        'Implementation of security and data protection.',
        'Design and implementation of data storage solutions.'
      ],
      [
        'Code, test and operate node.js based services and help QA and other teams for server-based testing.',
        'Effectively use tools and ingenuity to identify and fix defects before they become a problem.',
        'Independently create complete solutions from scratch.',
        'Implement and maintain monitoring and alerting.',
        'Share knowledge and help colleagues.'
      ]
    ]
  },
  {
    id: 'jr-dev',
    name: 'Junior Developer',
    img: '/images/careers/apply-banner.jpg',
    jobRole: [
      [
        '2+ years of experience as a Node.js Developer or backend developer.',
        'In depth knowledge of Node.js.',
        'Strong proficiency with JavaScript.',
        'Good understanding of at least one of AngularJS or React JS.',
        'A basic understanding of front-end technologies.',
        'Understanding the nature of asynchronous programming and its quirks and workarounds.',
        'Knowledge of OOPs and Design Patterns.',
        'Strong knowledge of cloud.'
      ],
      [
        'Ability to quickly get up to speed with existing code.',
        'Open-minded and keen to learn.',
        'Strong analytical skills and problem solving aptitude.',
        'Proficient understanding of code versioning tools, such as Git.',
        'Experience with Deployment to deploy updates and fixes.',
        'Knowledge of Ruby or Python will be a plus.',
        'Experience with Firebase will be a plus.'
      ]
    ],
    duties: [
      [
        'Integration of user-facing elements developed by a front-end developers with server side logic.',
        'Building reusable code and libraries for future use.',
        'Optimization of the application for maximum speed and scalability.',
        'Implementation of security and data protection.',
        'Design and implementation of data storage solutions.'
      ],
      [
        'Code, test and operate node.js based services and help QA and other teams for server-based testing.',
        'Effectively use tools and ingenuity to identify and fix defects before they become a problem.',
        'Independently create complete solutions from scratch.',
        'Implement and maintain monitoring and alerting.',
        'Share knowledge and help colleagues.'
      ]
    ]
  },
  {
    id: 'pr-manager',
    name: 'Project Manager',
    img: '/images/careers/apply-banner.jpg',
    jobRole: [
      [
        '2+ years of experience as a Node.js Developer or backend developer.',
        'In depth knowledge of Node.js.',
        'Strong proficiency with JavaScript.',
        'Good understanding of at least one of AngularJS or React JS.',
        'A basic understanding of front-end technologies.',
        'Understanding the nature of asynchronous programming and its quirks and workarounds.',
        'Knowledge of OOPs and Design Patterns.',
        'Strong knowledge of cloud.'
      ],
      [
        'Ability to quickly get up to speed with existing code.',
        'Open-minded and keen to learn.',
        'Strong analytical skills and problem solving aptitude.',
        'Proficient understanding of code versioning tools, such as Git.',
        'Experience with Deployment to deploy updates and fixes.',
        'Knowledge of Ruby or Python will be a plus.',
        'Experience with Firebase will be a plus.'
      ]
    ],
    duties: [
      [
        'Integration of user-facing elements developed by a front-end developers with server side logic.',
        'Building reusable code and libraries for future use.',
        'Optimization of the application for maximum speed and scalability.',
        'Implementation of security and data protection.',
        'Design and implementation of data storage solutions.'
      ],
      [
        'Code, test and operate node.js based services and help QA and other teams for server-based testing.',
        'Effectively use tools and ingenuity to identify and fix defects before they become a problem.',
        'Independently create complete solutions from scratch.',
        'Implement and maintain monitoring and alerting.',
        'Share knowledge and help colleagues.'
      ]
    ]
  },
  {
    id: 'qa',
    name: 'Quality Analyst',
    img: '/images/careers/apply-banner.jpg',
    jobRole: [
      [
        '2+ years of experience as a Node.js Developer or backend developer.',
        'In depth knowledge of Node.js.',
        'Strong proficiency with JavaScript.',
        'Good understanding of at least one of AngularJS or React JS.',
        'A basic understanding of front-end technologies.',
        'Understanding the nature of asynchronous programming and its quirks and workarounds.',
        'Knowledge of OOPs and Design Patterns.',
        'Strong knowledge of cloud.'
      ],
      [
        'Ability to quickly get up to speed with existing code.',
        'Open-minded and keen to learn.',
        'Strong analytical skills and problem solving aptitude.',
        'Proficient understanding of code versioning tools, such as Git.',
        'Experience with Deployment to deploy updates and fixes.',
        'Knowledge of Ruby or Python will be a plus.',
        'Experience with Firebase will be a plus.'
      ]
    ],
    duties: [
      [
        'Integration of user-facing elements developed by a front-end developers with server side logic.',
        'Building reusable code and libraries for future use.',
        'Optimization of the application for maximum speed and scalability.',
        'Implementation of security and data protection.',
        'Design and implementation of data storage solutions.'
      ],
      [
        'Code, test and operate node.js based services and help QA and other teams for server-based testing.',
        'Effectively use tools and ingenuity to identify and fix defects before they become a problem.',
        'Independently create complete solutions from scratch.',
        'Implement and maintain monitoring and alerting.',
        'Share knowledge and help colleagues.'
      ]
    ]
  },
  {
    id: 'ux-dev',
    name: 'User Experience Designer',
    img: '/images/careers/apply-banner.jpg',
    jobRole: [
      [
        '2+ years of experience as a Node.js Developer or backend developer.',
        'In depth knowledge of Node.js.',
        'Strong proficiency with JavaScript.',
        'Good understanding of at least one of AngularJS or React JS.',
        'A basic understanding of front-end technologies.',
        'Understanding the nature of asynchronous programming and its quirks and workarounds.',
        'Knowledge of OOPs and Design Patterns.',
        'Strong knowledge of cloud.'
      ],
      [
        'Ability to quickly get up to speed with existing code.',
        'Open-minded and keen to learn.',
        'Strong analytical skills and problem solving aptitude.',
        'Proficient understanding of code versioning tools, such as Git.',
        'Experience with Deployment to deploy updates and fixes.',
        'Knowledge of Ruby or Python will be a plus.',
        'Experience with Firebase will be a plus.'
      ]
    ],
    duties: [
      [
        'Integration of user-facing elements developed by a front-end developers with server side logic.',
        'Building reusable code and libraries for future use.',
        'Optimization of the application for maximum speed and scalability.',
        'Implementation of security and data protection.',
        'Design and implementation of data storage solutions.'
      ],
      [
        'Code, test and operate node.js based services and help QA and other teams for server-based testing.',
        'Effectively use tools and ingenuity to identify and fix defects before they become a problem.',
        'Independently create complete solutions from scratch.',
        'Implement and maintain monitoring and alerting.',
        'Share knowledge and help colleagues.'
      ]
    ]
  }
];
